import * as yup from "yup";

const emailRegex =
  /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

const NUM_5 = 5;
const NUM_320 = 320;
const emailYup = yup
  .string()
  .min(NUM_5, "required min input 5 characters")
  .max(NUM_320, "required max input 320 characters")
  .email("required email format")
  .matches(emailRegex, "required email format")
  .required("required");

export default emailYup;
